import { JsonProperty, Serializable } from 'ts-jackson'
import { Fromable } from '../model'

@Serializable()
export class ReportConfigEntity extends Fromable {
  @JsonProperty('id')
  id!: string

  @JsonProperty('reportCode')
  reportCode!: string

  @JsonProperty('reportUrl')
  reportUrl!: string
}
